import soundcloudConfig from "../../config/soundcloudConfig";

function withTimeout(timeoutMs = soundcloudConfig.FETCH_TIMEOUT_MS) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  return { controller, timeout };
}

export async function fetchJson(url, options = {}) {
  const { timeoutMs, headers = {} } = options;
  const { controller, timeout } = withTimeout(timeoutMs);

  try {
    const response = await fetch(url, {
      method: "GET",
      signal: controller.signal,
      headers: {
        Accept: "application/json",
        "Accept-Language": "en-US,en;q=0.9",
        ...headers,
      },
    });

    if (!response.ok) {
      const body = await response.text().catch(() => "");
      throw new Error(`Request failed with status ${response.status}${body ? `: ${body}` : ""}`);
    }

    return await response.json();
  } finally {
    clearTimeout(timeout);
  }
}
